const state = () => ({
  isValid: false,
  language: ''
});

const getters = {
  isValid(state) {
    return state.isValid;
  },
  language(state) {
    return state.language;
  }
};

const mutations = {
  setIsValid(state, payload) {
    state.isValid = payload;
  },
  updateLanguage(state, payload) {
    state.language = payload;
  },
  resetStore(storeState) {
    Object.assign(storeState, state());
  }
};

const actions = {
  updateLanguage({ commit }, payload) {
    commit('updateLanguage', payload);
  }
};

export const languageSelector = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
